import { ArdoqIconCategory, IconName } from '@ardoq/icons';

export const WORKSPACE_ICON_REPRESENTATION = {
  isImage: false,
  value: '',
  icon: {
    id: IconName.WORKSPACE,
    label: '',
    isSVG: true,
    category: ArdoqIconCategory.Ardoq,
    representation: 'none',
  },
};
